import React, { useCallback, useEffect, useMemo } from 'react'
import './styles.css'

import MenuIcon from '@mui/icons-material/Menu'
import LogoutIcon from '@mui/icons-material/Logout'
import { Navigation } from '../navigation/Navigation'
import { AppContent } from '../app-content/AppContent'
import { Login } from '../login/Login'
import { useLocalState } from '../../shared/UseLocalState'
import { authState } from '../../state/Auth.state'
import { appState } from '../../state/App.state'
import { Register } from '../register/Register'

import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import { initAppSubs } from '../../functions/init-subs.fun'
import { actualShowState } from '../../state/ActualShow.state'
import { Loading } from '../loading/Loading'
import { ForgotPassword } from '../forgotpassword/Forgotpassword'

export const App = () => {
  /* GLOBAL STATE */
  const loading = useLocalState<boolean>(actualShowState.loading$, actualShowState.loading$.value)
  const loggedIn = useLocalState(authState.user$, authState.user$.value)
  const guestMode = useLocalState(authState.guestMode$, authState.guestMode$.value)
  const hash = useLocalState(appState.hash$, appState.hash$.value)

  /* STATE */
  const [showMenu, setShowMenu] = React.useState(false)

  /* DERIVED STATE */
  const showNav = useMemo(() => (showMenu ? 'show-nav' : ''), [showMenu])
  const isAccessible = useMemo(() => !!loggedIn || guestMode, [loggedIn, guestMode])

  /* LOGIC */
  const toggleShowMenu = useCallback(() => {
    setShowMenu(!showMenu)
  }, [showMenu])
  const hashChange = useCallback(() => {
    appState.hash$.next(window.location.hash)
  }, [])

    useEffect(() => {
        authState.tryAutoLogin()
    }, [])

  /* INIT */
  useEffect(() => {
    window.addEventListener('hashchange', hashChange)
    // init user sub
    const subs = initAppSubs()
    return () => {
      window.removeEventListener('hashchange', hashChange)
      // destroy user sub
      subs?.forEach((sub) => sub.unsubscribe())
    }
  }, [hashChange])

  /* TEMPLATE */
  if (hash === '#/register' && !loggedIn) {
    return <Register />
  }

  if (hash === '#/forgotpassword' && !loggedIn) {
    return <ForgotPassword />
  }

  if (hash === '#/history' && !isAccessible) {
    authState.loginAsGuest()
    return null
  }

  if (!isAccessible) {
    return <Login />
  }

  return (
    <>
      <Loading loading={loading} />
      <div className='app-container'>
        <div className='topbar'>
          <div className='menu-btn'>
            <MenuIcon sx={{ height: '2rem', width: '2rem' }} onClick={toggleShowMenu} />
          </div>
          <span style={{ flex: 1, color: 'white', fontWeight: 500, fontSize: '1rem', paddingLeft: '0.5rem' }}>
            {hash === '#/history' ? 'IGV Datenbank'
              : hash === '#/horses' ? 'Pferd registrieren'
              : hash === '#/person-register' ? 'Personenregister'
              : hash === '#/address-change' ? 'Adressänderung'
              : hash === '#/registration' ? 'Online-Nennung'
              : ''}
          </span>
          <LogoutIcon
            sx={{ height: '2rem', width: '2rem', color: 'white', paddingRight: '0.5rem', cursor: 'pointer' }}
            onClick={() => {
              appState.hash$.next('#/home')
              window.location.hash = '#/home'
              authState.logout()
            }}
            titleAccess='Abmelden'
          />
        </div>
        <div className={`navigation ${showNav}`}>
          <Navigation loggedIn={!!loggedIn} linkClicked={() => setShowMenu(false)} />
        </div>
        <div className='app-content' onClick={() => setShowMenu(false)}>
          <AppContent />
        </div>
      </div>
    </>
  )
}
